/* eslint-disable import/no-default-export */
/* eslint-disable react/default-props-match-prop-types */
/* eslint-disable react/require-default-props */
/* eslint-disable react/forbid-prop-types */
/* eslint-disable complexity */
/* eslint-disable react/prop-types */
import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import Card from 'components/card'
import Image from 'components/image'
import { InfoButton } from 'components/buttons'
import {
  openAddToCartModal,
  openFundThisGiftModal,
  openRedirectModal,
  openReservationModal,
  openReservePurchasedGiftModal,
} from 'registry/modals/actions'
import CrowdfundAction from 'registry/components/reg-item-card/guest-actions/crowdfund-action'
import { BabylistOffer } from 'registry/components/add-or-buy/components/babylist-offer'
import { GroupGiftOffer } from 'registry/components/add-or-buy/components/group-gift-offer'
import { Offer } from 'registry/components/add-or-buy/components/offer'
import { PurchasedAction } from 'registry/components/add-or-buy/components/purchased-action'
import { createReservation } from 'registry/actions'
import { reservationsPath } from 'lib/urls'
import { track, useTracking } from 'lib/analytics'

export const FavorOffer = ({ inCart, onClick }) => (
  <div>
    <div className="flex">
      <div>
        <Image
          src="//res.cloudinary.com/babylist/image/upload/v1631884941/bl_store_icon_o8u8vu.png"
          width={44}
        />
      </div>
      <div className="flex-grow col ptm plm">
        <div className="flex">
          <div className="text-bold h5 flex grow mbn">Help &amp; Favors</div>
        </div>
      </div>
    </div>
    <div>
      {inCart ? (
        <InfoButton
          href={reservationsPath}
          pill
          block
          empty
          className="mtl pam"
        >
          Gifted By You
        </InfoButton>
      ) : (
        <InfoButton pill block className="mtl pam" onClick={onClick}>
          Give This Gift
        </InfoButton>
      )}
    </div>
  </div>
)

export const OtherStoreOffers = ({ regItem, offers, openRedirectModal }) => {
  const babylistOffer = offers && offers.find((o) => o.isBabylist)
  const hasAdditionalOffers = babylistOffer && offers.length > 1
  const hasOtherOffers = !babylistOffer && offers.length >= 1

  const sectionTitle = () => {
    if (babylistOffer && offers.length > 1) {
      return 'Or Buy Directly From'
    }
    return 'Buy Directly From'
  }

  return (
    <div className={hasAdditionalOffers || hasOtherOffers ? 'pbl' : 'pan'}>
      {(hasAdditionalOffers || hasOtherOffers) && (
        <div className="text-bold man">{sectionTitle()}</div>
      )}
      {offers.map((offer) => {
        if (!offer.isBabylist) {
          return (
            <Offer
              key={offer.id}
              offer={offer}
              regItem={regItem}
              openRedirectModal={openRedirectModal}
            />
          )
        }
      })}
    </div>
  )
}

export const AddOrBuy = (
  {
    offers,
    regItem,
    registry,
    openAddToCartModal,
    openRedirectModal,
    openFundThisGiftModal,
    openReservePurchasedGiftModal,
    createReservation,
    reservation,
  },
  { isMobile }
) => {
  const { firstNames } = registry
  const {
    goalAmount,
    isFavor,
    isGiftCard,
    isAvailableOnBabylist,
    isGroupGift,
    isCrowdfund,
  } = regItem
  const babylistOffer = offers && offers.find((o) => o.isBabylist)

  const tracker = useTracking()

  const Wrapper = ({ children }) => {
    if (!isMobile) {
      return <Card className="pal">{children}</Card>
    }
    return <div className="mtl">{children}</div>
  }

  const trackedCreateReservation = (...args) =>
    createReservation(...args).then((reservation) => {
      const { email, userId } = reservation
      tracker.trackEvent({
        event: track.emailCaptured,
        eventLocation: track.EventLocation.GIFT_GIVER_MINUS_EMAIL_COLLECTION,
        eventUrl: window.location.href,
        email,
        userId,
      })
      return reservation
    })

  return (
    <Wrapper>
      {!!goalAmount && isGroupGift && (
        <GroupGiftOffer
          regItem={regItem}
          registry={registry}
          openFundThisGiftModal={() => openFundThisGiftModal(regItem)}
          openReservationModal={() =>
            openAddToCartModal(regItem, trackedCreateReservation)
          }
          openReservePurchasedGiftModal={() =>
            openReservePurchasedGiftModal(
              regItem,
              registry,
              trackedCreateReservation
            )
          }
        />
      )}
      {!isGroupGift &&
        babylistOffer &&
        !isFavor &&
        (isAvailableOnBabylist || offers.length >= 1) && (
          <BabylistOffer
            price={babylistOffer.price}
            registryFirstNames={firstNames}
            onClick={() =>
              openAddToCartModal(regItem, trackedCreateReservation)
            }
            regItem={regItem}
            inCart={!!reservation}
          />
        )}
      {isFavor && (
        <FavorOffer
          regItem={regItem}
          onClick={() => openAddToCartModal(regItem, trackedCreateReservation)}
          inCart={!!reservation}
        />
      )}
      {isCrowdfund && <CrowdfundAction regItem={regItem} />}
      {offers && !isGroupGift && !isFavor && !isGiftCard && (
        <>
          <OtherStoreOffers
            regItem={regItem}
            offers={offers}
            openRedirectModal={openRedirectModal}
          />
          <PurchasedAction
            openReservePurchasedGiftModal={() =>
              openReservePurchasedGiftModal(
                regItem,
                registry,
                trackedCreateReservation
              )
            }
          />
        </>
      )}
    </Wrapper>
  )
}

AddOrBuy.propTypes = {
  regItem: PropTypes.object.isRequired,
  offers: PropTypes.array.isRequired,
}

AddOrBuy.contextTypes = {
  isMobile: PropTypes.bool,
}

AddOrBuy.defaultProps = {
  regItem: {},
}

export default connect(null, {
  openAddToCartModal,
  openReservationModal,
  openRedirectModal,
  openFundThisGiftModal,
  openReservePurchasedGiftModal,
  createReservation,
})(AddOrBuy)
